(() => {
  'use strict';
  let sequence = 0;

  function enhance(wrapper) {
    if (wrapper.dataset.damaVideoReady) return;
    const video = wrapper.querySelector('video');
    const button = wrapper.querySelector('[data-dama-video-play]');
    if (!video || !button) return;
    wrapper.dataset.damaVideoReady = 'true';
    if (!video.id) {
      let id;
      do { id = `dama-controlled-video-${++sequence}`; }
      while (document.getElementById(id));
      video.id = id;
    }
    button.setAttribute('aria-controls', video.id);
    video.tabIndex = 0;
    let userPaused = false;
    let automaticPause = false;
    let visible = false;
    let starting = false;

    function focusVideo() {
      if (document.activeElement === button) video.focus({preventScroll: true});
    }

    function nativeControls(state) {
      wrapper.dataset.videoState = state;
      video.controls = true;
      focusVideo();
      button.hidden = true;
      button.disabled = false;
    }

    function showPlay() {
      if (video.error) return nativeControls('error');
      wrapper.dataset.videoState = video.ended ? 'ended' : 'ready';
      video.controls = false;
      button.hidden = false;
      button.disabled = false;
      if (document.activeElement === video) button.focus({preventScroll: true});
    }

    button.addEventListener('click', async () => {
      userPaused = false;
      button.disabled = true;
      wrapper.dataset.videoState = 'loading';
      try {
        await video.play();
      } catch {
        nativeControls('unavailable');
      } finally {
        button.disabled = false;
      }
    });
    video.addEventListener('play', () => { userPaused = false; nativeControls('playing'); });
    video.addEventListener('pause', () => {
      if (!automaticPause && visible && !document.hidden && !video.ended) userPaused = true;
      automaticPause = false;
      if (!video.ended && !video.error) nativeControls('paused');
    });
    video.addEventListener('ended', showPlay);
    video.addEventListener('error', () => nativeControls('error'));
    if (video.paused) showPlay();
    else nativeControls('playing');

    // Only a visible product film starts automatically. Other shared players stay manual.
    if (wrapper.closest('[data-dama-product-gallery]') && 'IntersectionObserver' in window) {
      const mobile = matchMedia('(max-width: 899px)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      const canAutoplay = () => !wrapper.hasAttribute('data-dama-manual-video') && visible && mobile.matches && !document.hidden &&
        !userPaused && !video.ended && !reducedMotion.matches && !navigator.connection?.saveData;
      const pauseAutomatically = () => {
        if (!video.paused) { automaticPause = true; video.pause(); }
      };
      const update = async () => {
        if (!visible || document.hidden || reducedMotion.matches) { pauseAutomatically(); return; }
        if (!canAutoplay() || starting || !video.paused) return;
        starting = true;
        try {
          await video.play();
        } catch (error) {
          if (error.name === 'NotAllowedError' && canAutoplay()) {
            video.muted = true;
            try { await video.play(); } catch { showPlay(); }
          } else showPlay();
        } finally {
          starting = false;
          if (!visible || document.hidden) pauseAutomatically();
        }
      };
      new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
        update();
      }, {threshold: [0, .5]}).observe(video);
      document.addEventListener('visibilitychange', update);
      mobile.addEventListener('change', update);
      reducedMotion.addEventListener('change', update);
    }
  }

  function initialize(root) {
    if (root.matches?.('[data-dama-video]')) enhance(root);
    root.querySelectorAll('[data-dama-video]').forEach(enhance);
  }

  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
